module.exports = __webpack_public_path__ + "f4d4778caa17d50c16979623fab3cd2d.MP3";